var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27363",
    "data-name": "Group 27363",
    transform: "translate(-1727.938 -9636.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27287",
    "data-name": "Group 27287",
    transform: "translate(1728 9637)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 56.5,
    cy: 56.5,
    r: 56.5,
    transform: "translate(-0.063 -0.063)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27286",
    "data-name": "Group 27286",
    transform: "translate(35.681 42.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53021",
    "data-name": "Path 53021",
    d: "M-19398.795,9992.43h37.176",
    transform: "translate(19398.795 -9978.201)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53022",
    "data-name": "Path 53022",
    d: "M-19328.008,9977.768l14.424,14.424-14.424,14.424",
    transform: "translate(19351.176 -9977.768)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.d19662b22790ed260f366bfbe545a201.svg";
export { ForwardRef as ReactComponent };